import React, { PureComponent } from 'react';
import { Row, Col } from 'antd';
import { UploadPicture } from '../../../tools';
import './index.less';

//图片广告位项

interface IProps {
    sourceRoot?: {
        image?: string;
    };
    tip: string;
    value: any;
    uploadAction?: string;
    onChange: (e: any) => void;
}

export class UploadImg extends PureComponent<IProps> {
    handleChangeItem = (path: any) => {
        const { onChange } = this.props;
        onChange(path);
    };
    render() {
        const { value, uploadAction, sourceRoot, tip } = this.props;
        return (
            <Row className="entry-item upload-img-wrap">
                <Col className="entry-item-image" span={5}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={value}
                        uploadAction={uploadAction}
                        onChange={(path) => this.handleChangeItem(path)}
                    />
                </Col>
                <Col className="entry-item-content" span={17}>
                    <div className="tip">{tip}</div>
                </Col>
            </Row>
        );
    }
}
